/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Factual_Neat_Ostrich_ArriveInputs */

const fr_factual_neat_ostrich_arrive = /** @type {(inputs: Factual_Neat_Ostrich_ArriveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instructions additionnelles (optionnel)`)
};

/**

* @param {Factual_Neat_Ostrich_ArriveInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const factual_neat_ostrich_arrive = /** @type {((inputs?: Factual_Neat_Ostrich_ArriveInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Factual_Neat_Ostrich_ArriveInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_factual_neat_ostrich_arrive(inputs)
});